<template>
    <div>
        <VJoyLabel v-if="label">{{ label }}</VJoyLabel>
        <VJoyInputDigit
            v-model="modelValue"
            :length="length"
            :invalid="hasErrorMessage"
            :disabled="disabled"
            :input-aria-label="ariaLabel"
            :name="name"
        />
        <VJoyFormError v-if="hasErrorMessage" data-testid="otp-input-error">{{ errorMessage }}</VJoyFormError>
    </div>
</template>

<script setup lang="ts">
    import {computed, watch} from 'vue';
    import {VJoyFormError, VJoyLabel, VJoyInputDigit} from '@maltjoy/core-vue';

    interface Props {
        /**
         * The label to display above the input
         */
        label?: string;
        /**
         * Number of digits to display in the input
         */
        length?: number;
        /**
         * The error message to display below the input
         */
        errorMessage?: string;
        /**
         * Whether the input is disabled
         */
        disabled?: boolean;
        /**
         * The aria label to use for the input
         */
        ariaLabel?: string;
        /**
         * The name of the input for the form
         */
        name?: string;
    }

    const props = withDefaults(defineProps<Props>(), {
        length: 6,
        disabled: false,
    });

    const emit = defineEmits<{
        complete: [];
    }>();

    const modelValue = defineModel<string>();

    const hasErrorMessage = computed(() => Boolean(props.errorMessage));

    watch(modelValue, (value) => {
        if (value?.length === props.length) {
            emit('complete');
        }
    });
</script>
